import { render, staticRenderFns } from "./ResourceCollectionTree.vue?vue&type=template&id=53c15ae0"
import script from "./ResourceCollectionTree.vue?vue&type=script&lang=js"
export * from "./ResourceCollectionTree.vue?vue&type=script&lang=js"
import style0 from "./ResourceCollectionTree.vue?vue&type=style&index=0&id=53c15ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports